import { render } from "./com_general.vue?vue&type=template&id=b86d2ebc"
import script from "./com_general.vue?vue&type=script&lang=js"
export * from "./com_general.vue?vue&type=script&lang=js"

import "./com_general.vue?vue&type=style&index=0&id=b86d2ebc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__